import { JobNotificationCardModel } from '../job-notification-card.model';

export class SpreadsheetDashboardNotificationCardModel extends JobNotificationCardModel {}
